import { render, staticRenderFns } from "./LiquidacionesTable.vue?vue&type=template&id=2a4fd417"
import script from "./LiquidacionesTable.vue?vue&type=script&lang=js"
export * from "./LiquidacionesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports